<template>
  <div>
    <div class="row page-title-header">
      <div class="col-12">
        <div class="page-header">
          <b-breadcrumb class="m-0">
            <b-breadcrumb-item :to="{ name: 'DashboardHome' }">
              <i class="fa fa-home"></i>
            </b-breadcrumb-item>
            <b-breadcrumb-item :to="{ name: 'PartnerMarketingEventList' }" v-if="fromEventPage">點數/商品兌換活動</b-breadcrumb-item>
            <b-breadcrumb-item v-if="fromEventPage && parentEvent" @click="backToEventPlans">{{ parentEvent.name }} - 兌換活動方案</b-breadcrumb-item>
            <b-breadcrumb-item :to="{ name: 'PartnerMarketingPlanList' }" v-if="!fromEventPage">兌換活動方案</b-breadcrumb-item>
            <b-breadcrumb-item active>{{ isEdit ? '編輯' : '新增' }}方案</b-breadcrumb-item>
          </b-breadcrumb>
        </div>
      </div>
    </div>
    <b-card>
      <div class="row d-flex mb-4 mb-xl-2 justify-content-between">
        <h4 class="col-12 col-xl-6 mb-2 mb-xl-0 font-weight-bold">
          {{ isEdit ? '編輯' : '新增' }}兌換活動方案
        </h4>
      </div>
      <b-overlay :show="isLoading">
        <b-form @submit.prevent="onSubmit" ref="formRef">
          <b-form-group label-cols="12" label-cols-lg="2" label-size="sm" label="活動名稱" label-for="name">
            <b-form-input id="name" v-model="form.name" :state="errors.name ? false : null" :disabled="isView || isLoading" />
            <b-form-invalid-feedback v-if="errors.name">{{ errors.name }}</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label-cols="12" label-cols-lg="2" label-size="sm" label="點數/商品兌換活動" label-for="partner_marketing_event_id">
            <AppSingleSelect
              v-model="selectedEvent"
              :options="events"
              @input="setEventId"
              :disabled="isView || isEdit || isLoading || fromEventPage"
            />
            <b-form-invalid-feedback v-if="errors.partner_marketing_event_id">{{ errors.partner_marketing_event_id }}</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label-cols="12" label-cols-lg="2" label-size="sm" label="狀態" label-for="status">
            <b-form-select v-model="form.status" :options="statusOptions" :disabled="isView || isLoading" />
            <b-form-invalid-feedback v-if="errors.status">{{ errors.status }}</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label-cols="12" label-cols-lg="2" label-size="sm" label="上架時間" label-for="start_at">
            <div class="d-flex flex-column flex-xl-row align-items-start align-items-xl-center">
              <datepicker
                placeholder="選擇日期"
                v-model="start_at"
                bootstrap-styling
                format="yyyy-MM-dd"
                :language="zh"
                :disabled="isView || isLoading"
                clear-button
              />
            </div>
            <b-form-invalid-feedback v-if="errors.start_at">{{ errors.start_at }}</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label-cols="12" label-cols-lg="2" label-size="sm" label="下架時間" label-for="end_at">
            <div class="d-flex flex-column flex-xl-row align-items-start align-items-xl-center">
              <datepicker
                placeholder="選擇日期"
                v-model="end_at"
                bootstrap-styling
                format="yyyy-MM-dd"
                :language="zh"
                :disabled="isView || isLoading"
                clear-button
                :disabledDates="disabledDates"
              />
            </div>
            <b-form-invalid-feedback v-if="errors.end_at">{{ errors.end_at }}</b-form-invalid-feedback>
            <b-form-invalid-feedback :state="endAtValidationState">{{ endAtValidationMessage }}</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label-cols="12" label-cols-lg="2" label-size="sm" label="兌換開始日" label-for="exchange_start_at">
            <div class="d-flex flex-column flex-xl-row align-items-start align-items-xl-center">
              <datepicker
                placeholder="選擇日期"
                v-model="exchange_start_at"
                bootstrap-styling
                format="yyyy-MM-dd"
                :language="zh"
                :disabled="isView || isLoading"
                clear-button
              />
            </div>
            <b-form-invalid-feedback v-if="errors.exchange_start_at">{{ errors.exchange_start_at }}</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label-cols="12" label-cols-lg="2" label-size="sm" label="兌換截止日" label-for="exchange_end_at">
            <div class="d-flex flex-column flex-xl-row align-items-start align-items-xl-center">
              <datepicker
                placeholder="選擇日期"
                v-model="exchange_end_at"
                bootstrap-styling
                format="yyyy-MM-dd"
                :language="zh"
                :disabled="isView || isLoading"
                clear-button
                :disabledDates="disabledDates"
              />
            </div>
            <b-form-invalid-feedback v-if="errors.exchange_end_at">{{ errors.exchange_end_at }}</b-form-invalid-feedback>
            <b-form-invalid-feedback :state="exchangeEndAtValidationState">{{ exchangeEndAtValidationMessage }}</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label-cols="12" label-cols-lg="2" label-size="sm" label="序號使用開始時間" label-for="code_start_at">
            <div class="d-flex flex-column flex-xl-row align-items-start align-items-xl-center">
              <datepicker
                placeholder="選擇日期"
                v-model="code_start_at"
                bootstrap-styling
                format="yyyy-MM-dd"
                :language="zh"
                :disabled="isView || isLoading"
                clear-button
              />
            </div>
            <b-form-invalid-feedback v-if="errors.code_start_at">{{ errors.code_start_at }}</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label-cols="12" label-cols-lg="2" label-size="sm" label="序號使用結束時間" label-for="code_end_at">
            <div class="d-flex flex-column flex-xl-row align-items-start align-items-xl-center">
              <datepicker
                placeholder="選擇日期"
                v-model="code_end_at"
                bootstrap-styling
                format="yyyy-MM-dd"
                :language="zh"
                :disabled="isView || isLoading"
                clear-button
                :disabledDates="disabledDates"
              />
            </div>
            <b-form-invalid-feedback v-if="errors.code_end_at">{{ errors.code_end_at }}</b-form-invalid-feedback>
            <b-form-invalid-feedback :state="codeEndAtValidationState">{{ codeEndAtValidationMessage }}</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label-cols="12" label-cols-lg="2" label-size="sm" label="POYA點數" label-for="source_points">
            <b-form-input id="source_points" v-model="form.source_points" type="number" :state="errors.source_points ? false : null" :disabled="isView || isLoading" />
            <b-form-invalid-feedback v-if="errors.source_points">{{ errors.source_points }}</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label-cols="12" label-cols-lg="2" label-size="sm" label="兌換數量" label-for="target_points">
            <b-form-input id="target_points" v-model="form.target_points" type="number" :state="errors.target_points ? false : null" :disabled="isView || isLoading" />
            <b-form-invalid-feedback v-if="errors.target_points">{{ errors.target_points }}</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label-cols="12" label-cols-lg="2" label-size="sm" label="兌換單位" label-for="target_unit">
            <b-form-input id="target_unit" v-model="form.target_unit" :state="errors.target_unit ? false : null" :disabled="isView || isLoading" />
            <b-form-invalid-feedback v-if="errors.target_unit">{{ errors.target_unit }}</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label-cols="12" label-cols-lg="2" label-size="sm" label="每人兌換總組數上限" label-for="per_user_exchange_limit">
            <b-form-input id="per_user_exchange_limit" v-model="form.per_user_exchange_limit" type="number" :state="errors.per_user_exchange_limit ? false : null" :disabled="isView || isLoading" />
            <b-form-invalid-feedback v-if="errors.per_user_exchange_limit">{{ errors.per_user_exchange_limit }}</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label-cols="12" label-cols-lg="2" label-size="sm" label="排序" label-for="sort">
            <b-form-input id="sort" v-model="form.sort" type="number" placeholder="排序為必填" :state="errors.sort ? false : null" :disabled="isView || isLoading" />
            <b-form-invalid-feedback v-if="errors.sort">{{ errors.sort }}</b-form-invalid-feedback>
          </b-form-group>
          <div class="d-flex justify-content-center">
            <b-button class="mr-3" @click="goBackOrList" variant="outline-danger">返回</b-button>
            <b-button v-if="!isView" type="submit" variant="success">儲存</b-button>
          </div>
        </b-form>
      </b-overlay>
    </b-card>
  </div>
</template>

<script>
import partnerMarketingPlan from '@/apis/partnerMarketingPlan'
import partnerMarketingEvent from '@/apis/partnerMarketingEvent'
import AppSingleSelect from '@/components/AppSingleSelect.vue'
import Datepicker from "vuejs-datepicker"
import { zh } from "vuejs-datepicker/dist/locale"
import { format, set, isBefore, startOfDay } from "date-fns"
import { BButton, BCard, BForm, BFormGroup, BFormInput, BFormSelect, BFormInvalidFeedback, BOverlay, BBreadcrumb, BBreadcrumbItem } from 'bootstrap-vue'
export default {
  components: { AppSingleSelect, Datepicker, BButton, BCard, BForm, BFormGroup, BFormInput, BFormSelect, BFormInvalidFeedback, BOverlay, BBreadcrumb, BBreadcrumbItem },
  data() {
    return {
      zh,
      start_at: new Date(),
      end_at: new Date(),
      exchange_start_at: new Date(),
      exchange_end_at: new Date(),
      code_start_at: new Date(),
      code_end_at: new Date(),
      form: {
        name: '',
        status: 'public',
        start_at: '',
        end_at: '',
        exchange_start_at: '',
        exchange_end_at: '',
        code_start_at: '',
        code_end_at: '',
        source_points: '',
        target_points: '',
        target_unit: '',
        per_user_exchange_limit: '',
        image_url: '',
        partner_marketing_event_id: '',
        sort: null
      },
      events: [],
      selectedEvent: null,
      statusOptions: [
        { text: '公開', value: 'public' },
        { text: '草稿', value: 'draft' },
        { text: '關閉', value: 'closed' }
      ],
      isEdit: false,
      isView: false,
      isLoading: false,
      errors: {},
      parentEvent: null
    }
  },
  computed: {
    fromEventPage() {
      return !!this.$route.params.partnerMarketingEventId;
    },
    partnerMarketingPlanId() {
      return this.$route.params.partnerMarketingPlanId || this.$route.query.copyFromId;
    },
    isFromCopy() {
      return !!this.$route.query.copyFromId;
    },
    // 下架時間驗證狀態
    endAtValidationState() {
      if (!this.end_at) return null
      const today = startOfDay(new Date())
      const selectedEndDate = startOfDay(new Date(this.end_at))
      if (isBefore(selectedEndDate, today)) {
        return false
      }
      if (this.start_at && this.end_at) {
        const startDate = startOfDay(new Date(this.start_at))
        const endDate = startOfDay(new Date(this.end_at))
        if (isBefore(endDate, startDate)) {
          return false
        }
      }
      return null
    },
    endAtValidationMessage() {
      if (!this.end_at) return ''
      const today = startOfDay(new Date())
      const selectedEndDate = startOfDay(new Date(this.end_at))
      if (isBefore(selectedEndDate, today)) {
        return '結束時間 不得早於 目前時間'
      }
      if (this.start_at && this.end_at) {
        const startDate = startOfDay(new Date(this.start_at))
        const endDate = startOfDay(new Date(this.end_at))
        if (isBefore(endDate, startDate)) {
          return '結束時間 不得早於 開始時間'
        }
      }
      return ''
    },
    // 兌換截止日驗證狀態
    exchangeEndAtValidationState() {
      if (!this.exchange_end_at) return null
      const today = startOfDay(new Date())
      const selectedEndDate = startOfDay(new Date(this.exchange_end_at))
      if (isBefore(selectedEndDate, today)) {
        return false
      }
      if (this.exchange_start_at && this.exchange_end_at) {
        const startDate = startOfDay(new Date(this.exchange_start_at))
        const endDate = startOfDay(new Date(this.exchange_end_at))
        if (isBefore(endDate, startDate)) {
          return false
        }
      }
      return null
    },
    exchangeEndAtValidationMessage() {
      if (!this.exchange_end_at) return ''
      const today = startOfDay(new Date())
      const selectedEndDate = startOfDay(new Date(this.exchange_end_at))
      if (isBefore(selectedEndDate, today)) {
        return '結束時間 不得早於 目前時間'
      }
      if (this.exchange_start_at && this.exchange_end_at) {
        const startDate = startOfDay(new Date(this.exchange_start_at))
        const endDate = startOfDay(new Date(this.exchange_end_at))
        if (isBefore(endDate, startDate)) {
          return '結束時間 不得早於 開始時間'
        }
      }
      return ''
    },
    // 序號使用結束時間驗證狀態
    codeEndAtValidationState() {
      if (!this.code_end_at) return null
      const today = startOfDay(new Date())
      const selectedEndDate = startOfDay(new Date(this.code_end_at))
      if (isBefore(selectedEndDate, today)) {
        return false
      }
      if (this.code_start_at && this.code_end_at) {
        const startDate = startOfDay(new Date(this.code_start_at))
        const endDate = startOfDay(new Date(this.code_end_at))
        if (isBefore(endDate, startDate)) {
          return false
        }
      }
      return null
    },
    codeEndAtValidationMessage() {
      if (!this.code_end_at) return ''
      const today = startOfDay(new Date())
      const selectedEndDate = startOfDay(new Date(this.code_end_at))
      if (isBefore(selectedEndDate, today)) {
        return '結束時間 不得早於 目前時間'
      }
      if (this.code_start_at && this.code_end_at) {
        const startDate = startOfDay(new Date(this.code_start_at))
        const endDate = startOfDay(new Date(this.code_end_at))
        if (isBefore(endDate, startDate)) {
          return '結束時間 不得早於 開始時間'
        }
      }
      return ''
    },
    // 禁用日期
    disabledDates() {
      return {
        to: new Date(new Date().setHours(0, 0, 0, 0) - 1)
      }
    }
  },
  async created() {
    this.isEdit = !!this.$route.params.partnerMarketingPlanId && !this.$route.name.includes('Create')
    this.isView = this.$route.name.includes('View')
    
    if (this.fromEventPage) {
      await this.fetchParentEvent();
    } else {
      await this.fetchEvents();
    }
    
    if (this.isEdit || this.isFromCopy) {
      this.isLoading = true
      partnerMarketingPlan.getPartnerMarketingPlan(this.partnerMarketingPlanId).then(res => {
        const data = res.data.data
        Object.assign(this.form, data)
        this.start_at = data.start_at && new Date(data.start_at)
        this.end_at = data.end_at && new Date(data.end_at)
        this.exchange_start_at = data.exchange_start_at && new Date(data.exchange_start_at)
        this.exchange_end_at = data.exchange_end_at && new Date(data.exchange_end_at)
        this.code_start_at = data.code_start_at && new Date(data.code_start_at)
        this.code_end_at = data.code_end_at && new Date(data.code_end_at)
        
        if (this.isFromCopy) {
          delete this.form.id
          this.form.name = `(複製) ${this.form.name}`
          this.form.status = 'draft'
        }
        
        // Set selected event for standalone pages
        if (!this.fromEventPage && this.form.partner_marketing_event_id) {
          this.selectedEvent = this.events.find(e => e.value === this.form.partner_marketing_event_id);
          if (!this.selectedEvent && data.partner_marketing_event) {
            // If event not in list, add it
            this.selectedEvent = {
              text: data.partner_marketing_event.name,
              value: data.partner_marketing_event_id
            };
            this.events.push(this.selectedEvent);
          }
        }
      }).finally(() => {
        this.isLoading = false
      })
    } else {
      // 新增模式：取得目前最大 sort 值並設定預設值
      const eventId = this.$route.params.partnerMarketingEventId || this.form.partner_marketing_event_id
      if (eventId) {
        this.isLoading = true
        partnerMarketingPlan.getMaxSort(eventId).then(res => {
          const maxSort = res.data.data.max_sort || 0
          this.form.sort = maxSort + 1
        }).catch(() => {
          // 如果取得失敗，預設值為 1
          this.form.sort = 1
        }).finally(() => {
          this.isLoading = false
        })
      }
    }
  },
  methods: {
    goBackOrList() {
      this.$router.back()
    },
    handleFormatDates() {
      this.form.start_at = this.doHandleFormatDates(this.start_at, 0, 0, 0)
      this.form.end_at = this.doHandleFormatDates(this.end_at, 23, 59, 59)
      this.form.exchange_start_at = this.doHandleFormatDates(this.exchange_start_at, 0, 0, 0)
      this.form.exchange_end_at = this.doHandleFormatDates(this.exchange_end_at, 23, 59, 59)
      this.form.code_start_at = this.doHandleFormatDates(this.code_start_at, 0, 0, 0)
      this.form.code_end_at = this.doHandleFormatDates(this.code_end_at, 23, 59, 59)
    },
    doHandleFormatDates(datetime, hours, minutes, seconds) {
      if (!datetime) return null

      return format(
        set(new Date(datetime), {
          hours,
          minutes,
          seconds,
        }),
        "yyyy-MM-dd HH:mm:ss"
      )
    },
    uploadImage(imageBase64) {
      this.isLoading = true
      partnerMarketingPlan.uploadImageByBase64({ image: imageBase64 }).then(res => {
        this.form.image_url = res.data.data.url
      }).finally(() => {
        this.isLoading = false
      })
    },
    onSubmit() {
      this.errors = {}
      if (!this.form.name) this.errors.name = '請輸入名稱'
      if (!this.fromEventPage && !this.isEdit && !this.form.partner_marketing_event_id) this.errors.partner_marketing_event_id = '請選擇點數/商品兌換活動'
      if (!this.form.status) this.errors.status = '請選擇狀態'
      if (!this.start_at) this.errors.start_at = '請選擇開始時間'
      if (!this.end_at) this.errors.end_at = '請選擇結束時間'
      if (!this.form.source_points) this.errors.source_points = '請輸入來源點數'
      if (!this.form.target_points) this.errors.target_points = '請輸入目標點數'
      if (!this.form.target_unit) this.errors.target_unit = '請輸入目標單位'
      if (!this.form.per_user_exchange_limit) this.errors.per_user_exchange_limit = '請輸入每人兌換總組數上限'
      if (!this.form.sort) this.errors.sort = '此欄位為必填'

      // 檢查時間驗證
      if (this.endAtValidationState === false) {
        this.errors.end_at = this.endAtValidationMessage
      }
      if (this.exchangeEndAtValidationState === false) {
        this.errors.exchange_end_at = this.exchangeEndAtValidationMessage
      }
      if (this.codeEndAtValidationState === false) {
        this.errors.code_end_at = this.codeEndAtValidationMessage
      }

      if (Object.keys(this.errors).length > 0) return
      this.isLoading = true

      this.handleFormatDates()

      let action;

      if (this.isEdit) {
        action = partnerMarketingPlan.updatePartnerMarketingPlan(this.$route.params.partnerMarketingPlanId, this.form);
      } else {
        // For create, use different API based on whether it's nested route
        if (this.fromEventPage) {
          action = partnerMarketingPlan.createPartnerMarketingPlanForEvent(this.$route.params.partnerMarketingEventId, this.form);
        } else {
          action = partnerMarketingPlan.createPartnerMarketingPlan(this.form);
        }
      }

      action.then(() => {
        const successMessage = this.isEdit ? '修改成功' : '新增成功'
        this.$swal.fire({
          type: 'success',
          text: successMessage
        }).then(() => {
          this.goBackOrList()
        })
      }).catch(error => {
        this.showErrorMessage(error)
      }).finally(() => {
        this.isLoading = false
      })
    },
    async fetchParentEvent() {
      try {
        const response = await partnerMarketingEvent.getPartnerMarketingEvent(this.$route.params.partnerMarketingEventId);
        this.parentEvent = response.data.data;

        // 設定 selectedEvent 並加入 events 選項（用於顯示）
        this.selectedEvent = {
          text: this.parentEvent.name,
          value: this.parentEvent.id
        };
        if (!this.events.find(e => e.value === this.parentEvent.id)) {
          this.events.push(this.selectedEvent);
        }
      } catch (error) {
        console.error('Failed to fetch parent event:', error);
      }
    },
    backToEventPlans() {
      this.$router.push({ 
        name: 'PartnerMarketingPlanListByEvent',
        params: { partnerMarketingEventId: this.$route.params.partnerMarketingEventId }
      });
    },
    async fetchEvents() {
      if (this.events.length > 0) return;
      try {
        const { data } = await partnerMarketingEvent.getPartnerMarketingEvents({ all: true });
        data.data.forEach((event) => {
          this.events.push({
            text: event.name,
            value: event.id,
          });
        });
      } catch (error) {
        console.error('Failed to fetch events:', error);
        this.$bvToast.toast('載入點數/商品兌換活動失敗', { variant: 'danger', solid: true });
      }
    },
    setEventId(event) {
      if (event) {
        this.form.partner_marketing_event_id = event.value;
        // 新增模式：選擇活動後，取得該活動內的最大 sort 值並設定預設值
        if (!this.isEdit && !this.isView) {
          this.isLoading = true;
          partnerMarketingPlan.getMaxSort(event.value).then(res => {
            const maxSort = res.data.data.max_sort || 0;
            this.form.sort = maxSort + 1;
          }).catch(() => {
            // 如果取得失敗，預設值為 1
            this.form.sort = 1;
          }).finally(() => {
            this.isLoading = false;
          });
        }
      } else {
        this.form.partner_marketing_event_id = '';
        // 清空排序預設值
        if (!this.isEdit && !this.isView) {
          this.form.sort = null;
        }
      }
    },
    showErrorMessage(error) {
      console.error(error);
      const {status, data} = error.response || {};

      // 錯誤訊息對應表
      const errorMessageMap = {
        'end at 必須等於 start at 或更晚': '下架時間 不得早於 上架時間',
        'exchange end at 必須等於 exchange start at 或更晚': '兌換截止日 不得早於 兌換開始日',
        'code end at 必須等於 code start at 或更晚': '序號使用結束時間 不得早於 序號開始時間'
      }

      let html = "未知錯誤";
      if (status && status === 422 && data && data.message) {
        // Handle validation errors - map them to form fields
        if (typeof data.message === 'object') {
          Object.keys(data.message).forEach(key => {
            const fieldName = key === 'per_user_exchange_limit' ? 'per_user_exchange_limit' : key
            let errorMsg = Array.isArray(data.message[key]) ? data.message[key][0] : data.message[key]
            // 轉換錯誤訊息
            errorMsg = errorMessageMap[errorMsg] || errorMsg
            this.errors[fieldName] = errorMsg
          })
          // Show all errors in swal
          html = Object.values(data.message)
            .map((m) => {
              const msg = Array.isArray(m) ? m[0] : m
              return errorMessageMap[msg] || msg
            })
            .join("<br/>");
        } else {
          html = errorMessageMap[data.message] || data.message;
        }
      } else if (data && data.message) {
        html = errorMessageMap[data.message] || data.message;
      }

      this.$swal.fire({
        type: "error",
        title: "儲存失敗",
        html,
      });
    }
  }
}
</script>